module.exports = __webpack_public_path__ + "images/emoji/relaxed.be420851d2828f2fd6ac.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/relaxed.png
// module id = ps6I
// module chunks = 13